module.exports = __webpack_public_path__ + "img/bg.86492f56.jpg";